<template>
  <div>
    <fragment v-if="assertion">{{ value }}</fragment>
    <fragment v-else>
      <v-tooltip bottom>
        <span slot="activator">
          <v-icon color="error" style="cursor: pointer;">warning</v-icon>
        </span>
        <span>{{ warningMessage }}</span>
      </v-tooltip>
    </fragment>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    assertion: {
      type: Boolean,
      required: true,
    },
    warningMessage: {
      type: String,
      required: true,
    },
  },
};
</script>
